import { Controller } from '@hotwired/stimulus';
import { Toast } from 'bootstrap';

export default class extends Controller {
	static targets = ["template"];

	connect() {
		this.showToastHandler = this.showToast.bind(this);
		window.addEventListener('toast:show', this.showToastHandler);
	}

	showToast(event) {
		const {
			message,
			type = 'info',
			title = '',
			duration = 5000,
		} = event.detail;

		// Create the element.
		const toastElement = this.templateTarget.content.cloneNode(true).firstElementChild;
		const bodyElement = toastElement.querySelector(".toast-body");
		if (bodyElement) {
			bodyElement.textContent = message;
		} else {
			console.error("No body element in toast template");
		}

		const titleElement = toastElement.querySelector(".toast-header .toast-title");
		if (titleElement) {
			titleElement.textContent = title;
		} else {
			console.error("No title element in toast template");
		}

		if (!title) {
			const headerElement = toastElement.querySelector(".toast-header");

			headerElement.style["display"] = "none";
		}

		// Add it to the DOM...
		this.element.appendChild(toastElement);

		// ... and let Bootstrap manage it.
		const toast = new Toast(toastElement, {
			autohide: duration > 0,
			delay: duration > 0 ? duration : 5000,
		});

		toastElement.addEventListener('hidden.bs.toast', () => {
			toastElement.remove();
		});

		toast.show();
	}
}
